<template>
  <div class="container sync-check-page">
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>

    <div class="content">
      <h2>九航同步商品核对</h2>
      <h3>数据筛选</h3>
      <el-form ref="searchForm" :inline="true" :model="searchForm" size="small" class="search-form">
        <el-form-item label="商品名称" prop="goodsName">
          <el-input v-model.trim="searchForm.goodsName" clearable placeholder="五域/九航商品名称"></el-input>
        </el-form-item>
        <el-form-item label="商品编号" prop="goodsNo">
          <el-input v-model.trim="searchForm.goodsNo" clearable placeholder="请输入完整商品编号"></el-input>
        </el-form-item>
        <el-form-item label="SKU" prop="sku">
          <el-input v-model.trim="searchForm.sku" clearable placeholder="请输入SKU"></el-input>
        </el-form-item>
        <el-form-item label="五域商品状态" prop="wyGoodsStatus">
          <el-select v-model="searchForm.wyGoodsStatus" clearable placeholder="请选择">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="九航商品状态" prop="jhGoodsStatus">
          <el-select v-model="searchForm.jhGoodsStatus" clearable placeholder="请选择">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="五域SKU状态" prop="wySkuStatus">
          <el-select v-model="searchForm.wySkuStatus" clearable placeholder="请选择">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="九航SKU状态" prop="jhSkuStatus">
          <el-select v-model="searchForm.jhSkuStatus" clearable placeholder="请选择">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核对结果" prop="exceptionFlag">
          <el-select v-model="searchForm.exceptionFlag" clearable placeholder="请选择">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="异常" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品添加日期" prop="createdTimeRange">
          <el-date-picker
            v-model="createdTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商品更新日期" prop="updatedTimeRange">
          <el-date-picker
            v-model="updatedTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button type="primary" plain @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="content">
      <div class="list-header">
        <h3>SKU级核对明细</h3>
        <div>
          <span class="legend"><i></i>九航数据</span>
          <el-button type="primary" :loading="exportLoading" @click="exportAll">导出全部查询结果</el-button>
        </div>
      </div>

      <el-table
        v-loading="loading"
        :data="list"
        border
        stripe
        max-height="650"
        :cell-class-name="cellClassName"
        :header-cell-style="headerCellStyle">
        <el-table-column label="基础信息" fixed="left">
          <el-table-column prop="goodsNo" label="商品编号" width="125"></el-table-column>
          <el-table-column prop="sku" label="SKU" width="155"></el-table-column>
          <el-table-column prop="exceptionDetail" label="核对结果" width="170">
            <template slot-scope="scope">
              <el-tag :type="scope.row.exceptionFlag === 1 ? 'danger' : 'success'" size="mini">
                {{ scope.row.exceptionDetail }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="五域数据">
          <el-table-column prop="wyGoodsName" label="商品名称" width="220" show-overflow-tooltip></el-table-column>
          <el-table-column prop="wySkuName" label="SKU名称" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="wySkuNo" label="SKU编号" width="100"></el-table-column>
          <el-table-column prop="wyGoodsStatus" label="商品状态" width="90">
            <template slot-scope="scope">{{ statusLabel(scope.row.wyGoodsStatus) }}</template>
          </el-table-column>
          <el-table-column prop="wySkuStatus" label="SKU状态" width="90">
            <template slot-scope="scope">{{ statusLabel(scope.row.wySkuStatus) }}</template>
          </el-table-column>
          <el-table-column prop="wyMarketPrice" label="市场价" width="90"></el-table-column>
          <el-table-column prop="wyRetailPrice" label="零售价" width="90"></el-table-column>
          <el-table-column prop="wyCostPrice" label="成本价" width="90"></el-table-column>
          <el-table-column prop="wyPreCostPrice" label="前次成本价" width="100"></el-table-column>
          <el-table-column prop="wyPurchasePrice" label="内购价" width="90"></el-table-column>
          <el-table-column prop="wySettlementPrice" label="结算价" width="90"></el-table-column>
          <el-table-column prop="wyConvertPrice" label="折算价" width="90"></el-table-column>
          <el-table-column prop="wyBulkPurchasePrice" label="集采价" width="90"></el-table-column>
          <el-table-column prop="wyAgentPrice" label="代理价" width="90"></el-table-column>
          <el-table-column prop="wyGoodsCreatedTime" label="添加时间" width="160"></el-table-column>
          <el-table-column prop="wyGoodsUpdatedTime" label="更新时间" width="160"></el-table-column>
        </el-table-column>

        <el-table-column label="九航数据">
          <el-table-column prop="jhGoodsName" label="商品名称" width="220" show-overflow-tooltip></el-table-column>
          <el-table-column prop="jhSkuName" label="SKU名称" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="jhSkuNo" label="SKU编号" width="100"></el-table-column>
          <el-table-column prop="jhGoodsStatus" label="商品状态" width="90">
            <template slot-scope="scope">{{ statusLabel(scope.row.jhGoodsStatus) }}</template>
          </el-table-column>
          <el-table-column prop="jhSkuStatus" label="SKU状态" width="90">
            <template slot-scope="scope">{{ statusLabel(scope.row.jhSkuStatus) }}</template>
          </el-table-column>
          <el-table-column prop="jhRecordedWySkuStatus" label="记录的五域状态" width="125">
            <template slot-scope="scope">{{ statusLabel(scope.row.jhRecordedWySkuStatus) }}</template>
          </el-table-column>
          <el-table-column prop="jhMarketPrice" label="市场价" width="90"></el-table-column>
          <el-table-column prop="jhRetailPrice" label="零售价" width="90"></el-table-column>
          <el-table-column prop="jhCostPrice" label="成本价" width="90"></el-table-column>
          <el-table-column prop="jhPurchasePrice" label="内购价" width="90"></el-table-column>
          <el-table-column prop="jhWholesalePrice" label="集采价" width="90"></el-table-column>
          <el-table-column prop="jhGoodsCreatedTime" label="添加时间" width="160"></el-table-column>
          <el-table-column prop="jhGoodsUpdatedTime" label="更新时间" width="160"></el-table-column>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalNum"
        :current-page="page.pageNo"
        :page-size="page.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodsSyncCheck',
  data () {
    return {
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '商品列表', path: 'goodsList', type: '0' },
          { title: '九航同步商品核对', path: '', type: '1' }
        ]
      },
      searchForm: this.defaultSearchForm(),
      createdTimeRange: [],
      updatedTimeRange: [],
      statusOptions: [
        { label: '上架', value: 1 },
        { label: '下架', value: 0 }
      ],
      list: [],
      loading: false,
      exportLoading: false,
      page: {
        pageNo: 1,
        pageSize: 20,
        totalNum: 0
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    defaultSearchForm () {
      return {
        goodsName: '',
        goodsNo: '',
        sku: '',
        wyGoodsStatus: 1,
        jhGoodsStatus: null,
        wySkuStatus: null,
        jhSkuStatus: null,
        exceptionFlag: null
      }
    },
    buildParams (withPage) {
      const params = Object.assign({}, this.searchForm)
      if (withPage) {
        params.pageNo = this.page.pageNo
        params.pageSize = this.page.pageSize
      }
      if (this.createdTimeRange && this.createdTimeRange.length === 2) {
        params.createdTimeStart = this.createdTimeRange[0]
        params.createdTimeEnd = this.createdTimeRange[1]
      }
      if (this.updatedTimeRange && this.updatedTimeRange.length === 2) {
        params.updatedTimeStart = this.updatedTimeRange[0]
        params.updatedTimeEnd = this.updatedTimeRange[1]
      }
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === undefined) delete params[key]
      })
      return params
    },
    fetchData () {
      this.loading = true
      this.$api.goodsSyncCheckPage(this.buildParams(true)).then(res => {
        const data = res.data || {}
        this.list = data.list || []
        this.page.totalNum = data.totalNum || 0
      }).finally(() => {
        this.loading = false
      })
    },
    search () {
      this.page.pageNo = 1
      this.fetchData()
    },
    reset () {
      this.searchForm = this.defaultSearchForm()
      this.createdTimeRange = []
      this.updatedTimeRange = []
      this.page.pageNo = 1
      this.fetchData()
    },
    handleSizeChange (size) {
      this.page.pageSize = size
      this.page.pageNo = 1
      this.fetchData()
    },
    handleCurrentChange (pageNo) {
      this.page.pageNo = pageNo
      this.fetchData()
    },
    exportAll () {
      this.exportLoading = true
      this.$api.goodsSyncCheckExport(this.buildParams(false)).then(res => {
        this.downloadlink(res.data)
        this.$message.success('导出成功')
      }).finally(() => {
        this.exportLoading = false
      })
    },
    statusLabel (status) {
      const option = this.statusOptions.find(item => item.value === status)
      return option ? option.label : '--'
    },
    cellClassName ({ row, column }) {
      if (column.property && column.property.indexOf('jh') === 0) return 'jh-data-cell'
      if (column.property === 'exceptionDetail' && row.exceptionFlag === 1) return 'exception-cell'
      return ''
    },
    headerCellStyle ({ column }) {
      if ((column.property && column.property.indexOf('jh') === 0) || column.label === '九航数据') {
        return { background: '#fff1d6', color: '#8a5200' }
      }
      return null
    }
  }
}
</script>

<style scoped>
.content {
  margin-bottom: 16px;
}

.search-form .el-input,
.search-form .el-select {
  width: 190px;
}

.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.list-header h3 {
  margin: 0;
}

.legend {
  margin-right: 16px;
  color: #8a5200;
}

.legend i {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 5px;
  vertical-align: -2px;
  background: #fff7e8;
  border: 1px solid #f1c77c;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

/deep/ .el-table .jh-data-cell {
  background: #fff7e8 !important;
}

/deep/ .el-table .exception-cell {
  background: #fff0f0 !important;
}
</style>
